import { Box, Paper, Typography } from "@mui/material";
import WorkflowCreatesiefiles from "./workflows/WorkflowCreatesiefiles";

export function SieExport() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "1rem",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: "800px",
          justifyContent: "center",
          gap: "1rem",
        }}
      >
        <Typography variant="h5">SIE Export</Typography>
        <Paper>
          <WorkflowCreatesiefiles />
        </Paper>
      </div>
    </Box>
  );
}
